import { z } from 'zod';

export const OpportunitySubmissionCandidateListSchema = z.object({
  candidateIds: z.array(z.string().uuid()).nullish(),
});

export type CandidateReorder = z.infer<
  typeof OpportunitySubmissionCandidateListSchema
>;
